import React, { useState, useEffect, useReducer, useCallback, useMemo, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { Box, Button, ButtonBase, CircularProgress } from '@material-ui/core';
import moment from 'moment';
import { connect } from 'react-redux';
import _ from 'lodash';
import { CommentIcon, NotiIcon, AckDetailIcon } from '../../../../components/Icon';
import { Comments, Drop } from '../index';
import { i18n } from '../../../../language';
import { ehandoverAPI } from '../../../../apis';
import getFileType from '../../../../utils/getFileType';
import { userRoleList } from '../../../../utils/userRole';
import ehandoverIds from '../../../../ids/Ehandover';
import FileCom from '../../../../components/FileCom';
import useTags from '../../../../utils/useTags';
import useRetryApi from '../../../../utils/useRetryApi';
import { initValue, escapeHtmlKeepUrls, classNames } from '../../../../utils';
import useCheckLogin from '../../../../utils/useCheckLogin';
import UnCheckReminder from '../Comments/UnCheckReminder';
import CompleteTaskPopup from '../Comments/CompleteTaskPopup';
// import testJson from '../../testData.json';
import {
  getCompleteTaskApiParams,
  getSendToDisplayName,
  getUnCompleteTaskApiParams,
} from '../../../../utils/eHandoverUtil';
import { getTaskRepeatLable } from '../../../../utils/checkDateForRules';
import UpdateThisOneDialog from '../UpdateThisOneDialog';
import AckDetailDialog from '../AckDetailDialog';
import Checknote from './checknote';
import EditTask from './EditTask';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.font.white,
    borderRadius: '0.9375rem',
    minWidth: '31.25rem',
    marginBottom: '1.25rem',
  },
  noteBody: ({ todayFlag }) => ({
    backgroundColor: todayFlag && 'rgba(130, 221, 240,0.15)',
    padding: '1.875rem',
    borderTopLeftRadius: '0.9375rem',
    borderTopRightRadius: '0.9375rem',
  }),
  head: {
    display: 'flex',
    marginBottom: '0.938rem',
  },
  dateIcon: {
    borderRadius: '0.5rem',
    border: '0.0625rem solid #e4e7eb',
  },
  headIcon: {
    width: '2.55rem',
    height: '0.95rem',
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.625rem',
    fontWeight: 'bold',
    color: theme.palette.font.white,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '0.468rem 0.468rem 0 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  numIcon: {
    width: '2.55rem',
    height: '1.65rem',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.125rem',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#001d63',
    backgroundColor: theme.palette.font.white,
    borderRadius: '0 0 0.468rem 0.468rem',
  },
  dateInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  name: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    letterSpacing: '0',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  time: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
  },
  body: { marginBottom: '2.188rem' },
  context: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    wordWrap: 'break-word',
    whiteSpace: 'pre-line',
    wordBreak: 'normal',
    marginBottom: '1.313rem',
    '&>a': {
      display: 'inline-flex',
      fontSize: '1rem',
      color: '#538fff',
      fontFamily: 'NotoSans-Medium',
      lineHeight: 0,
    },
  },
  view: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
  foot: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  tag: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0.0218rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    paddingRight: '1rem',
    display: 'flex',
    alignItems: 'center',
  },
  tagicon: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    textAlign: 'center',
    letterSpacing: '0.013rem',
    color: theme.palette.font.white,
    fontWeight: '600',
    margin: '0.5rem 0.625rem 0.5rem 0',
    backgroundColor: '#979bff',
    height: '1.536rem',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0.5rem',
    borderRadius: '0.25rem',
  },
  comments: {
    border: '1px solid #538FFF',
    background: 'linear-gradient(0deg, #F5FAFF 0%, #F5FAFF 100%), #28D2AB',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0',
    color: '#538FFF',
    fontWeight: '500',
    textTransform: 'capitalize',
    height: '2.857rem',
    minWidth: 'max-content',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  sendTo: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0.0218rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
    paddingRight: '1rem',
    display: 'flex',
    alignItems: 'center',
  },
  commenticon: {
    fontSize: '1.4rem',
    color: '#538FFF',
    marginTop: '0.4rem',
  },
  notiIconBg: {
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '50%',
    backgroundColor: '#ffc95c',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexShrink: 0,
  },
  notiIcon: {
    fontSize: '1.5rem',
    color: theme.palette.font.white,
  },
  createdBy: {
    fontFamily: 'NotoSans-Medium',
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    display: 'flex',
    alignItems: 'center',
  },
  fileTitle: {
    marginTop: '1.875rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0.35px',
    fontWeight: '500',
  },
  acknowledgeBtn: {
    height: '2.857rem',
    padding: '0.857rem 1.428rem',
    borderRadius: '8px',
    color: '#fff',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    textAlign: 'center',
    backgroundColor: '#4c93ff',
    minWidth: 'max-content',
  },
  disabledBtn: {
    backgroundColor: '#C0C6CB',
  },
  outerAckDetailBtn: {
    border: '1px solid #538FFF',
    background: 'linear-gradient(0deg, #F5FAFF 0%, #F5FAFF 100%), #28D2AB',
    borderRadius: '8px',
    padding: '0.857rem 0.5rem',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0',
    color: '#538FFF',
    fontWeight: '500',
    textTransform: 'capitalize',
    height: '2.857rem',
    minWidth: 'max-content',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  outerAckDetailIcon: {
    fontSize: '1.4rem',
    color: '#538FFF',
  }
}));

function fileReducer(state, action) {
  switch (action.type) {
    case 'add':
      return [...state, action.item];
    case 'reset':
      return [];
    default:
      throw new Error();
  }
}

const sortByNumericProperty = (key) => (a, b) => {
  const numA = Number(a[key]);
  const numB = Number(b[key]);

  // Handle invalid/missing numbers (NaN) to avoid breaking the sort
  if (isNaN(numA)) return 1;
  if (isNaN(numB)) return -1;

  return numA - numB;
};

const ctrlStyle = (control) => (control ? '0' : '0.9375rem');

function NewNote({
  comment,
  context,
  tags,
  time,
  name,
  noteIndex,
  detail,
  pin,
  postday,
  deletedDate,
  deletedBy,
  TASK_ID,
  commentsTotal,
  ufTaskWebdavFiles,
  deleteTaskAPI,
  pinTaskAPI,
  type,
  userRole,
  loginInfo,
  notificationId,
  createdBy,
  id,
  files,
  roomType,
  handleSearch,
  itemData,
  updater,
  isUpdate,
  updateFollowTotal,
  taskCheckList,
  pscForm,
  sendTo,
  getNewTaskItemListAPI,
  accessControl,
  individualUsers,
  setPendingAction = () => {},
  staffList,
  title,
  description,
  customRecurrenceConfig = null,
  isDetailPage = false,
  sinkCompletedToBottom = false,
  isHideCompletedItem = false,
  onHeightChange = () => {},
  setFocusedIndex = () => {},
  resetFocusedIndex = () => {}
}) {
  const [control, setControl] = React.useState(comment);
  const [commentsCount, setCommentsCount] = useState(initValue(commentsTotal, 0));
  const [fileList, fileDispatch] = useReducer(fileReducer, []);
  const isMyDraftTab = type === 'myDraft';
  const userInfo = userRoleList.getHospWard(userRole, null, null, loginInfo.userId);
  const todayFlag = moment(time).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && !isMyDraftTab;
  const classes = useStyles({ todayFlag });
  const [checkListLoading, setCheckListLoading] = useState(false);
  const [fileCtrl, setFileCtrl] = useState(0);
  const tagsList = useTags(roomType, tags);
  const [edit, setEdit] = useState(false);
  const { retryApiCall } = useRetryApi();
  const checkLogin = useCheckLogin();
  const [showUnCheckReminder, setShowUnCheckReminder] = useState(false);
  const [showCompleteTaskPopup, setShowCompleteTaskPopup] = useState(false);
  const [completeName, setCompleteName] = useState(loginInfo?.flag ? loginInfo.corpID.toUpperCase() : '');
  const needLogin = (accessControl?.isLoginUpdateItemYn ?? 'N') === 'Y';
  const commentNeedLogin = (accessControl?.isLoginAddNotesYn ?? 'N') === 'Y';
  const showAcknowledgeBtn = itemData?.mark === 'N';
  const disabledAckBtn = type === 'postDay' || !['PENDING', 'RESEND', null].includes(itemData?.acknowledgmentStatus);
  // 弹窗问是update一个还是整个系列task（仅Custom recurrence是true的schedule task适用）
  const [showUpdateThisOneDialog, setShowUpdateThisOneDialog] = useState(false);
  const [isJustThisOne, setIsJustThisOne] = useState(false);
  const [showAckDetailPop, setShowAckDetailPop] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const safeSetState = (setter, value) => {
    if (isMounted.current) {
      setter(value);
    }
  };


  // const taskCheckList = testJson?.taskItemList;

  // getTaskItemAPI
  const getTaskItemAPI = async (
    id,
    order = { ID: 'asc', TOGGLED_DATE: 'asc', IS_COMPLETE: 'desc', SORT_INDEX: 'asc' }
  ) => {
    try {
      setCheckListLoading(true);
      await ehandoverAPI.getTaskItemList(
        {
          order,
          taskId: id,
        },
        { isHideLoading: true }
      );

      await getNewTaskItemListAPI([id]);
      setCheckListLoading(false);
    } catch (error) {
      setCheckListLoading(false);
      console.log('-----Get TaskItem error----->', error);
    }
  };

  const { tasksList, readOnlyTaskList, taskRemarksList } = useMemo(() => {
    let thisTasksList = _.filter(taskCheckList, (item) => item.PARENT_ID === 0) ?? [];
    return {
      tasksList: thisTasksList,
      readOnlyTaskList: _.orderBy( thisTasksList, ["IS_COMPLETE", "ID"], ["asc", "asc"]),
      taskRemarksList: _.filter(taskCheckList, (item) => item.PARENT_ID !== 0) ?? [],
    };
  }, [taskCheckList, sinkCompletedToBottom]);

  const showCompleteAllBtn = useMemo(() => _.some(tasksList, (item) => item.IS_COMPLETE === 'N'), [tasksList]);
  const showUnCompleteAllBtn = useMemo(() => _.some(tasksList, (item) => item.IS_COMPLETE === 'Y'), [tasksList]);
  const attachmentIdsKey = useMemo(() => {
    return Array.isArray(ufTaskWebdavFiles) ? ufTaskWebdavFiles.join(',') : '';
  }, [ufTaskWebdavFiles]);
  const escapedContext = useMemo(() => {
    return context ? escapeHtmlKeepUrls(context) : '';
  }, [context]);

  const individualDisplayName = useMemo(() => {
    if (type === 'notification') {
      return (sendTo ?? itemData?.sendTo ?? []).map((s) => s.desc).join(', ');
    } else {
      return getSendToDisplayName({
        individualUsers,
        sendToRoomType: itemData?.sendToRoomType,
        sendToCorp: itemData?.sendToCorp,
      });
    }
  }, [individualUsers, itemData, sendTo, type]);
  const { fileImageList, fileAttachmentList } = useMemo(() => {
    return {
      fileImageList: [...fileList.filter((item) => getFileType(item.NAME) === 'picture')].sort(sortByNumericProperty("ID")),
      fileAttachmentList: [...fileList.filter((item) => getFileType(item.NAME) !== 'picture')].sort(sortByNumericProperty("ID")),
    };
  }, [fileList]);

  // update taskItem API
  const updateAPI = async ({ fieldList, subItemList, delSubItemList }) => {
    try {
      const params = {
        taskId: TASK_ID,
        fields: fieldList,
        subItems: subItemList,
        deleteSubItems: delSubItemList,
        title,
        description,
      };
      await ehandoverAPI.postUpdateItem(params);
      if (isDetailPage) {
        await handleSearch();
      } else {
        (async () => {
          await getTaskItemAPI(TASK_ID);
        })();
        updateFollowTotal();
      }
      onHeightChange?.();
    } catch (error) {
      console.log('-----Update taskItem error----->', error);
    }
  };

// Update getFileAPI signature
const getFileAPI = async ({ id, isCancelled }) => {
  try {
    const { result } = await ehandoverAPI.getFileCache(
      { attachmentId: id },
      { isHideLoading: true, isHideError: true }
    );

    // Check flag BEFORE setting state
    if (isCancelled && isCancelled()) {
      return; 
    }

    if (result) {
      safeSetState(fileDispatch, { type: 'add', item: result });
      safeSetState(setFileCtrl, (oldCount) => oldCount + 1);
    } else {
      safeSetState(setFileCtrl, (oldCount) => oldCount + 1);
      console.error('Failed to fetch file after retries');
    }
  } catch (error) {
    if (isCancelled && isCancelled()) return;
    safeSetState(setFileCtrl, (oldCount) => oldCount + 1);
    console.log('-----Get taskFile error----->', error);
  }
};

  // update Comments Count API
  const updateCommentsCountAPI = async (
    select = ['ID', 'TITLE', 'CREATED_BY', 'CREATED_DATE', 'COMMENTS_COUNT', 'DATE_START', 'UF_TASK_WEBDAV_FILES']
  ) => {
    try {
      const { result } = await ehandoverAPI.getTask({
        select,
        taskId: TASK_ID,
      });

      setCommentsCount(result.task.commentsCount);
    } catch (error) {
      console.log('-----Get Task error----->', error);
    }
  };

  useEffect(() => {
    let isCancelled = false;
    let ctrl = true;

    if (TASK_ID && ctrl) {
      setCommentsCount(commentsTotal);
      setFileCtrl(0);
      fileDispatch({ type: 'reset' });

      if (ufTaskWebdavFiles) {
        ufTaskWebdavFiles.forEach((item) => {
          // Pass the cancellation flag to getFileAPI
          getFileAPI({ id: item, isCancelled: () => isCancelled });
        });
      }
    }

    return () => {
      isCancelled = true; // Set flag to true on cleanup
      ctrl = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TASK_ID, commentsTotal, attachmentIdsKey]);

  useEffect(() => {
    if (TASK_ID && attachmentIdsKey && ufTaskWebdavFiles && fileCtrl === ufTaskWebdavFiles.length) {
      onHeightChange?.();
    }
  }, [fileCtrl, attachmentIdsKey, ufTaskWebdavFiles, TASK_ID, onHeightChange]);

  useEffect(() => {
    onHeightChange?.();
  }, [control, edit, onHeightChange, checkListLoading, taskCheckList, tagsList, createdBy, individualUsers, itemData, sendTo, type])

  const handleCancelEdit = useCallback(() => {
    setEdit(false);
    resetFocusedIndex();
  }, []);

  useEffect(() => {
    if(edit){
      setFocusedIndex();
    }
  }, [edit])

  const handleCompleteAll = () => {
    if (needLogin && !checkLogin()) {
      setPendingAction({
        callback: (completeName) => {
          const params = getCompleteTaskApiParams(tasksList, completeName);
          updateAPI(params);
        },
      });
      return;
    }
    // complete task 分两种情况
    // 如果setting页面没有勾需要登录 -> 保持以前一样，弹出可以选择用户
    // 如果勾上了 completeName 设置为当前登录用户
    if (!needLogin) {
      setShowCompleteTaskPopup(true);
    } else {
      completeAllConfirm();
    }
  };

  const handleUnCompleteAll = () => {
    if (needLogin && !checkLogin()) {
      setPendingAction({
        callback: () => {
          setShowUnCheckReminder(true);
        },
      });
      return;
    }
    setShowUnCheckReminder(true);
  };

  const completeAllConfirm = () => {
    // setting页面没有勾需要登录时,completeName弹窗选择的
    // 否则 completeName就是当前登录用户
    const loginStaffName = (loginInfo?.displayName || loginInfo?.corpID) ?? '';
    // api返回的corpId有可能跟当前登录的corpId有大小写区别，所以需要找回api的里面的corpId
    const finishNameFromApi = _.find(staffList, (item) => item?.value === completeName)?.text;
    const finishBy = needLogin ? loginStaffName : finishNameFromApi;
    const params = getCompleteTaskApiParams(tasksList, finishBy);
    updateAPI(params);
    setShowCompleteTaskPopup(false);
    setCompleteName(loginInfo?.flag ? loginInfo.corpID.toUpperCase() : '');
  };

  const handleUnCheckAll = () => {
    const params = getUnCompleteTaskApiParams(tasksList, taskRemarksList);
    updateAPI(params);
    setShowUnCheckReminder(false);
  };

  const NoteHeader = () => {
    return (
      <div className={classes.head}>
        <Box mr="0.813rem">
          {type === 'notification' ? (
            <div className={classes.notiIconBg}>
              <NotiIcon className={classes.notiIcon} />
            </div>
          ) : (
            <Box className={classes.dateIcon}>
              <div className={classes.headIcon}>{moment(time, 'YYYY/MM/DD').format('ddd')}</div>
              <div className={classes.numIcon}>{moment(time, 'YYYY/MM/DD').date()}</div>
            </Box>
          )}
        </Box>
        <div className={classes.dateInfo}>
          <div className={classes.name}>{pscForm ?? name}</div>
          <Box display="flex" flexDirection="column">
            <div className={classes.time}>
              {postday
                ? i18n.t('EHANDOVER_NOTE_SCHEDULED_ON', { time: moment(time).format('yyyy-MM-DD HH:mm') })
                : moment(time).format('YYYY-MM-DD HH:mm')}
            </div>
            {postday && customRecurrenceConfig?.customRecurrence && (
              <div className={classes.time}>{getTaskRepeatLable(postday, customRecurrenceConfig)}</div>
            )}
          </Box>
        </div>
      </div>
    );
  };

  const updateTaskAckStatus = async () => {
    const updateAck = async (corpId) => {
      try {
        await ehandoverAPI.updateTaskAcknowledgeStatus({ corpId: corpId, taskId: TASK_ID });
        if (_.isFunction(handleSearch)) {
          await handleSearch();
        }
      } catch (error) {
      }
    };

    if (!checkLogin()) {
      setPendingAction({
        callback:  async (completeName,{corpId = ""}) => {
          await updateAck(corpId);
        },
      });
      return;
    }
    await updateAck(userInfo.corpId);
  };

  // 监听登录状态变化,如果登陆前有check/uncheck,登录成功后继续完成操作
  useEffect(() => {
    // 如果需要登录才能评论，退出登录的时候关闭评论
    if (commentNeedLogin && !loginInfo?.flag && control) {
      setControl(false);
    }
  }, [loginInfo?.flag, commentNeedLogin]);

  const isHideCompletedItemMemo = useMemo(
    () => {
      switch (type) {
        case 'notification':
        case 'complete':
          return false;
        default:
          return isHideCompletedItem;
      };
    },
  [type, isHideCompletedItem]);

  return (
    <div className={classes.root}>
      <div
        className={classes.noteBody}
        style={{
          borderBottomRightRadius: ctrlStyle(control),
          borderBottomLeftRadius: ctrlStyle(control),
        }}
      >
        {edit ? (
          <EditTask
            checklist={tasksList}
            itemData={itemData}
            handleCancelEdit={handleCancelEdit}
            handleSearch={handleSearch}
            type={type}
            individualUsers={individualUsers}
            noteHeader={<NoteHeader />}
            customRecurrenceConfig={customRecurrenceConfig}
            isJustThisOne={isJustThisOne}
            isHideCompletedItem={isHideCompletedItemMemo}
            onHeightChange={onHeightChange}
          />
        ) : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="flex-start">
              <NoteHeader />
              {type !== 'requireAck' && (
                <Drop
                  id={id}
                  noteIndex={noteIndex}
                  detail={detail}
                  pin={pin}
                  deletedDate={deletedDate}
                  deletedBy={deletedBy}
                  deleteTaskAPI={(deleteOptions) =>
                    deleteTaskAPI(TASK_ID, initValue(userInfo.staffName, userInfo.corpId), deleteOptions)
                  }
                  pinTaskAPI={pinTaskAPI}
                  TASK_ID={TASK_ID}
                  type={type}
                  notificationId={notificationId}
                  roomType={roomType}
                  handleSearch={handleSearch}
                  setEdit={setEdit}
                  updater={updater}
                  isUpdate={isUpdate}
                  showAcknowledgeBtn={showAcknowledgeBtn}
                  setShowEditThisOneDialog={setShowUpdateThisOneDialog}
                  customRecurrenceConfig={customRecurrenceConfig}
                />
              )}
            </Box>
            <div className={classes.body}>
              {Boolean(context) && (
                <div
                  className={classes.context}
                  dangerouslySetInnerHTML={{
                    __html: escapedContext,
                  }}
                />
              )}
              {Array.isArray(ufTaskWebdavFiles) &&
                (fileCtrl === ufTaskWebdavFiles.length ? (
                  <FileCom imgData={fileImageList} fileData={fileAttachmentList} type="ehandover" onAllImagesLoaded={onHeightChange} />
                ) : (
                  <>
                    <Box
                      width="100%"
                      height="10rem"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      m="1.25rem 0"
                    >
                      <CircularProgress color="primary" />
                    </Box>
                    <div className={classes.fileTitle}>{`${i18n.t('EHANDOVER_NOTE_ATTACHMENT')}`}</div>
                    <Box
                      width="16.563rem"
                      height="3.125rem"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      m="1.25rem 0"
                    >
                      <CircularProgress color="primary" />
                    </Box>
                  </>
                ))}
              {type === 'notification' && (
                <FileCom imgData={files.imageIds} fileData={files.fileIds} type="notification" onAllImagesLoaded={onHeightChange}/>
              )}
              {tasksList?.length > 0 && (
                <Checknote
                  id={id}
                  tasksList={sinkCompletedToBottom ? readOnlyTaskList : tasksList}
                  taskRemarksList={taskRemarksList}
                  updateAPI={updateAPI}
                  type={type}
                  todayFlag={todayFlag}
                  loading={checkListLoading}
                  accessControl={accessControl}
                  setPendingAction={setPendingAction}
                  staffList={staffList}
                  completeName={completeName}
                  setCompleteName={setCompleteName}
                  isHideCompletedItem={isHideCompletedItemMemo}
                  onHeightChange={onHeightChange}
                />
              )}
              {!isMyDraftTab && (
                <Box display="flex" justifyContent="space-between" mt="2.5rem">
                  {!detail && (
                    <Link
                      id={ehandoverIds.taskItem + id + 1}
                      className={classes.view}
                      to={`/ehandover/detail&id=${initValue(TASK_ID, notificationId)}&type=${type}`}
                    >
                      {i18n.t('EHANDOVER_NOTE_VIEWALL')}
                    </Link>
                  )}
                  {tasksList?.length > 0 && (
                    <Box display="flex" gridGap="1.428rem">
                      {showCompleteAllBtn && (
                        <ButtonBase id="Complete All" className={classes.view} onClick={handleCompleteAll}>
                          {i18n.t('EHANDOVER_COMPLETE_ALL')}
                        </ButtonBase>
                      )}
                      {showUnCompleteAllBtn && (
                        <ButtonBase id="Uncheck All" className={classes.view} onClick={handleUnCompleteAll}>
                          {i18n.t('EHANDOVER_UNCHECK_ALL')}
                        </ButtonBase>
                      )}
                    </Box>
                  )}
                </Box>
              )}
            </div>
            <Box display="flex" gridGap="1rem" flexDirection="column">
              <div className={classes.foot} >
                <Box display="flex" alignItems="center" flexWrap="wrap">
                  <div
                    className={classes.tag}
                    key={`${TASK_ID}_tag_label`}
                    style={{
                      color: todayFlag ? '#2e4469' : '#7d86a9',
                    }}
                  >
                    {i18n.t('EHANDOVER_NOTE_TAG')}
                  </div>
                  {tagsList.map((tag) => (
                    <div className={classes.tagicon} key={`${TASK_ID}_${tag?.id ?? tag?.tagDesc ?? 'undefined'}`}>
                      {tag.tagDesc}
                    </div>
                  ))}
                </Box>
              </div>
              <div className={classes.foot}>
                {individualDisplayName && (
                  <Box display="flex" alignItems="center" flexWrap="wrap">
                    <div
                      className={classes.sendTo}
                      style={{
                        color: todayFlag ? '#2e4469' : '#7d86a9',
                      }}
                    >
                      {`${i18n.t('EHANDOVER_SEND_TO')}:`}&nbsp;{individualDisplayName}
                    </div>
                  </Box>
                )}

                {!isMyDraftTab && (
                  <Box display="flex" gridGap="0.5rem" alignItems="center" ml="auto">
                    {showAcknowledgeBtn && (
                      <>
                      <ButtonBase
                        id="bed_occupieddischarge_order_discharge"
                        className={classNames(classes.acknowledgeBtn, disabledAckBtn && classes.disabledBtn)}
                        onClick={updateTaskAckStatus}
                        disabled={disabledAckBtn}
                      >
                        {i18n.t('EHANDOVER_ACKNOWLEDGE')}
                      </ButtonBase>
                      {loginInfo?.flag && (<ButtonBase
                        id="ehd_ack_detail"
                        className={classes.outerAckDetailBtn}
                        onClick={() => {setShowAckDetailPop(true)}}
                      >
                        <AckDetailIcon className={classes.outerAckDetailIcon} />
                        {i18n.t('EHANDOVER_ACK_DETAIL')}
                      </ButtonBase>)}
                      </>
                    )}
                    {type === 'notification' ? (
                      <div className={classes.createdBy}>
                        {i18n.t('NOTIFICATION_PUBLISHED_BY', { value: createdBy ?? '' })}
                      </div>
                    ) : (
                      <Button
                        id={ehandoverIds.taskItem + id + 2}
                        className={classes.comments}
                        onClick={() => {
                          if (control) {
                            setControl(false);
                            resetFocusedIndex();
                          } else {
                            setControl(true);
                            setFocusedIndex();
                          }
                          onHeightChange?.();
                        }}
                      >
                        <CommentIcon className={classes.commenticon} />
                        {i18n.t('EHANDOVER_NOTE_UPDATE', { number: commentsCount })}
                      </Button>
                    )}
                  </Box>
                )}
              </div>
            </Box>
          </>
        )}
      </div>
      {control && (
        <Comments
          id={id}
          TASK_ID={TASK_ID}
          commentsCount={commentsCount}
          updateCommentsCountAPI={updateCommentsCountAPI}
          type={type}
          commentNeedLogin={commentNeedLogin}
          staffList={staffList}
          onHeightChange={onHeightChange}
          setFocusedIndex={setFocusedIndex}
          resetFocusedIndex={resetFocusedIndex}
        />
      )}
      <UnCheckReminder
        open={showUnCheckReminder}
        closePop={() => setShowUnCheckReminder(false)}
        handleUnCheckAll={handleUnCheckAll}
      />
      <CompleteTaskPopup
        open={showCompleteTaskPopup}
        setOpen={setShowCompleteTaskPopup}
        handleConfirm={completeAllConfirm}
        id={id}
        name={completeName}
        setName={setCompleteName}
        staffList={staffList}
      />
      {showUpdateThisOneDialog && (
        <UpdateThisOneDialog
          showUpdateDialog={showUpdateThisOneDialog}
          closePop={() => setShowUpdateThisOneDialog(false)}
          type={i18n.t('EHANDOVER_UNSENT_EDIT')}
          handleUpdate={({ isJustThisOne }) => {
            setIsJustThisOne(isJustThisOne);
            setEdit(true);
            onHeightChange?.();
          }}
        />
      )}
      {showAckDetailPop && (
        <AckDetailDialog open={showAckDetailPop} closePop={() => setShowAckDetailPop(false)} taskId={TASK_ID} />
      )}
    </div>
  );
}

export default NewNote;
